// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import axios from 'axios';
import VueAxios from 'vue-axios';
import GoogleAuth from 'vue-google-auth';

import App from './App';
import router from './router';

Vue.use(Buefy);
Vue.use(VueAxios, axios);
Vue.use(GoogleAuth, { clientID: '184589090101-vmt3k49spdfk688hbqn2kt4vucancqad.apps.googleusercontent.com' });
Vue.googleAuth().load();
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js